import { Component, Input, OnInit, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ResponseService } from '../../../../../../services/response.service';
import { KeyboardActivityService } from '../../../../../../services/keyboard-activity.service';
import { ConfigHelper } from 'app/services/config.helper';
import * as ErrorMessages from '../../../../../../errors/constants';
import { MyModal } from '../../../../../../components/common/my-modal/my-modal.component';
import * as fromRoot from '../../../../../../store/reducers';
import { AppUiActions, TestTakerActions } from '../../../../../../store/actions';
declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'extended-text-interaction',
    template: require('./extended-text-interaction.html'),
})
export class ExtendedTextInteractionComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() interaction: PgRendererDto.InteractionDefinition;
    extendedTextInteraction: PgRendererDto.ExtendedTextInteraction;
    private static globalFocusExist: boolean = false;
    isFocus: boolean = false;
    isReady: boolean = false;
    wordCount: number = 0;
    editorHeight: number = 300;
    editorBlurSubscription: Subscription;
    editorKeyUpSubscription: Subscription;
    editorCopySubscription: Subscription;
    editorCutSubscription: Subscription;
    domId: string;
    editorElement: HTMLElement;
    clipboardData: string;
    mode: string = _paragonConfig.mode;

    constructor(
        private store: Store<fromRoot.State>,
        private myModal: MyModal,
        private responseService: ResponseService,
        private keyboardActivityService: KeyboardActivityService,
        private elementRef: ElementRef
    ) {
    }

    ngOnInit() {
        this.extendedTextInteraction = this.interaction.ExtendedTextInteraction;
        this.domId = `#editor-container`;
        if (!ConfigHelper.isTdpMode()) {
            $(this.domId).attr("placeholder", this.extendedTextInteraction.PlaceHolderText);
        }
        this.setEditorHeight();
        $(".rightpane").css("padding-bottom", "0");

        this.keyboardActivityService.startRecording(this.interaction.InteractionId);
    }

    ngAfterViewInit() {
        this.setEditorHeight();

        this.editorElement = $(this.domId, this.elementRef.nativeElement)[0];
        this.editorElement.spellcheck = this.extendedTextInteraction.SpellCheckActive;
        if (ExtendedTextInteractionComponent.globalFocusExist === false) {
            this.editorElement.focus();
            ExtendedTextInteractionComponent.globalFocusExist = true;
            this.isFocus = true;
        }
        if (!ConfigHelper.isTdpMode()) {
            this.editorElement.innerHTML = null;
        }
        const response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            this.editorElement.innerHTML = response.Items[0].Text;
        }

        this.editorKeyUpSubscription = Observable.fromEvent(this.editorElement, "keyup")
            .do(x => this.wordCount = this.responseService.getWordCount(this.editorElement.innerText))
            .debounceTime(3000)
            .subscribe(x => this.setResponse());

        this.editorBlurSubscription = Observable.fromEvent(this.editorElement, "blur")
            .do(x => this.wordCount = this.responseService.getWordCount(this.editorElement.innerText))
            .subscribe(x => this.setResponse());

        this.editorCopySubscription = Observable.fromEvent<ClipboardEvent>(this.editorElement, "copy")
            .subscribe(x => this.clipboardData = this.getSelectionHtml());

        this.editorCopySubscription = Observable.fromEvent<ClipboardEvent>(this.editorElement, "cut")
            .subscribe(x => this.clipboardData = this.getSelectionHtml());

        setTimeout(() => {
            this.wordCount = this.responseService.getWordCount(this.editorElement.innerText);
            this.isReady = true;
        }, 500);
    }

    ngOnDestroy() {
        this.keyboardActivityService.stopRecording();
        this.responseService.flush(false)
                .catch(() => {
                    this.store.dispatch(new AppUiActions.HideLoadingOverlay());
                    this.myModal.showRegularDlg("Error", ErrorMessages.Navigation_Response_Saving);
                });
        if (this.editorKeyUpSubscription) {
            this.editorKeyUpSubscription.unsubscribe();
        }

        if (this.editorBlurSubscription) {
            this.editorBlurSubscription.unsubscribe();
        }

        if (this.editorCopySubscription) {
            this.editorCopySubscription.unsubscribe();
        }

        if (this.editorCutSubscription) {
            this.editorCutSubscription.unsubscribe();
        }
        if (this.isFocus) {
            ExtendedTextInteractionComponent.globalFocusExist = false;
        }
    }

    pasteHtmlAtCaret(html: string, selectPastedContent: boolean = false) {
        if (window.getSelection) {
            const sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                let range = sel.getRangeAt(0);
                range.deleteContents();

                // Range.createContextualFragment() would be useful here but is
                // only relatively recently standardized and is not supported in
                // some browsers (IE9, for one)
                const el = document.createElement("div");
                el.innerHTML = html;
                const frag = document.createDocumentFragment();
                let node, lastNode;
                while ( (node = el.firstChild) ) {
                    lastNode = frag.appendChild(node);
                }
                const firstNode = frag.firstChild;
                range.insertNode(frag);

                // Preserve the selection
                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    if (selectPastedContent) {
                        range.setStartBefore(firstNode);
                    } else {
                        range.collapse(true);
                    }
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
    }

    getSelectionHtml(): string {
        let html = "";
        if (typeof window.getSelection != "undefined") {
            const sel = window.getSelection();
            if (sel.rangeCount) {
                const container = document.createElement("div");
                for (let i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;
            }
        }
        return html;
    }

    setEditorHeight() {
        if (this.extendedTextInteraction.FillRestPanelSpace == true) {
            const paneContent = $(".pane-content");
            if (paneContent.length > 0) {
                const panelHeight = $(".pane-content")[0].clientHeight;
                this.editorHeight = panelHeight - $(this.domId)[0].offsetTop - 90;
            }
        } else if (this.extendedTextInteraction.ExpectedLines > 0) {
            if (this.extendedTextInteraction.ExpectedLines < 5) {
                this.editorHeight = this.extendedTextInteraction.ExpectedLines * 40;
            } else {
                this.editorHeight = this.extendedTextInteraction.ExpectedLines * 30;
            }
        }
    }

    setResponse() {
        const responseText = this.editorElement.innerHTML;
        if (responseText && responseText.length > 0) {
            this.responseService.setResponse(this.interaction, null, null, responseText, false, null);
        }
    }

    execCommand(command: string) {
        document.execCommand(command, false, null);
        this.setResponse();
    }

    paste() {
        this.pasteHtmlAtCaret(this.clipboardData, false);
        this.setResponse();
    }

    downloadWrittenResponse(filename, elId) {
        var elHtml = document.getElementById(elId).innerText;
        var link = document.createElement('a');
        link.setAttribute('download', filename);   
        link.setAttribute('href', 'data:' + 'text/doc' + ';charset=utf-8,' + encodeURIComponent(elHtml));
        link.click(); 
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/extended-text-interaction/extended-text-interaction.component.ts